// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

console.log("MW_DEBUG_JS_LOADED");

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import initMoneyWorksHeaderFooter from "./moneyworksHeaderFooter";
import initBlogFilter from "./blogFilter";


// Call the menu and infinite scroll functions
try {
  menuOpen();
} catch (e) {
  console.warn('MW_DEBUG: menuOpen failed', e);
}

try {
  infiniteScroll();
} catch (e) {
  console.warn('MW_DEBUG: infiniteScroll failed', e);
}

// Initialize MoneyWorks header and footer
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    try {
      initMoneyWorksHeaderFooter();
    } catch (e) {
      console.error('MW_DEBUG: initMoneyWorksHeaderFooter failed', e);
    }
    try {
      initBlogFilter();
    } catch (e) {
      console.error('MW_DEBUG: initBlogFilter failed', e);
    }
  });
} else {
  try {
    initMoneyWorksHeaderFooter();
  } catch (e) {
    console.error('MW_DEBUG: initMoneyWorksHeaderFooter failed', e);
  }
  try {
    initBlogFilter();
  } catch (e) {
    console.error('MW_DEBUG: initBlogFilter failed', e);
  }
}